import axios from "axios";
import * as myConstClass from "../Config/config.js";
import { Encrypt, Decrypt } from "../Helpers/Common";

const END_POINT = myConstClass.BACKEND_ENDPOINT;

const AUTH_TOKEN = myConstClass.AUTH_TOKEN;

const headers = {
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Credentials": true,
  "x-access-auth-token": "" + AUTH_TOKEN + "",
  "country": localStorage.getItem("country")
};




export async function GetvisionCheck() {
  return axios
    .post(END_POINT + "/common/versioncheck", "", {
      headers: headers,
    })
    .then((response) => {

      if (response.headers) {
        localStorage.setItem("country_id", response.headers["x-region"]);
      }
      return response;
    });
}

export async function submitInterest(postdata) {
  return await Encrypt(postdata).then((res) => {
    const postData = {
      digest: res,
    };
    return axios
      .post(END_POINT + "/common/addinterest", postData, {
        headers: headers,
      })
      .then((res) => {
        const data = res;
        return data;
      });
  });
}
export async function Getfaq(type = "", limit = "") {
  const postData = {
    type: type,
    limit: limit,
  };
  return axios
    .post(END_POINT + "/common/faq", postData, {
      headers: headers,
    })
    .then((response) => {
      return response;
    });
}

export async function getTopics() {
  return axios
    .post(END_POINT + "/common/getTopics", "", {
      headers: headers,
    })
    .then((response) => {
      return response;
    });
}

export async function GetUserData() {
  console.log("called");
  const data = localStorage.getItem("user-info");
  console.log(data);
  return await Decrypt(data).then((res) => {
    console.log(res);
    return res;
  });
}
